import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../constants/common'
import { useContentEdgesIntersection } from '../useContentEdgesIntersection'

import * as styles from './useContentEdgesShadow.module.css'

export function useContentEdgesShadow({
  intersectionDeps,
  shadow,
  shadowBottomClassName = styles.shadowBottom,
  shadowClassName = styles.shadow,
  shadowTopClassName = styles.shadowTop,
} = EMPTY_OBJECT) {
  const {
    bottomEndIntersectionRef,
    isIntersectingBottomEnd,
    isIntersectingTopEnd,
    topEndIntersectionRef,
  } = useContentEdgesIntersection({ intersectionDeps })

  const isVerticalScrollable = !isIntersectingTopEnd || !isIntersectingBottomEnd

  return {
    bottomEndIntersectionElement: (
      <div
        className={styles.bottomEndIntersectionArea}
        ref={bottomEndIntersectionRef}
      />
    ),
    bottomEndIntersectionRef,
    shadowElement:
      isVerticalScrollable || shadow ? (
        <div
          className={classNames(shadowClassName, {
            [shadowBottomClassName]: !isIntersectingBottomEnd || shadow,
            [shadowTopClassName]: !isIntersectingTopEnd,
          })}
        />
      ) : null,
    topEndIntersectionElement: (
      <div
        className={styles.topEndIntersectionArea}
        ref={topEndIntersectionRef}
      />
    ),
    topEndIntersectionRef,
  }
}
